<template>
  <div class="progress" >
    <div class="progress-bar bg-danger" role="progressbar" v-bind:style="{'width':value + '%'}"  v-bind:aria-valuenow="value" aria-valuemin="0" aria-valuemax="100"></div>
  </div>
</template>

<script>
    export default {
        name: "progress-bar",
        props: ['value'],
    }
</script>

<style scoped>
  .progress{
    height: 1px;
    margin: -30px 3px 30px;
  }
</style>
